module.exports = __webpack_public_path__ + "img/appBg-links--hero.080dd41e.svg";